import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  changeCreditCardAttr,
  selectCreditCardBrand,
  selectCreditCardParcel,
  selectPaymentCreditCard,
  validatorHandlerBlur,
} from '../../../actions/purchaseActions';

import CardInfo from './CreditCard/CardInfo';
import CardInfoMobile from './CreditCard/CardInfoMobile';
import CardBrand from './CreditCard/CardBrand';
import CardBrandMobile from './CreditCard/CardBrandMobile';
import PaymentDeadline from './CreditCard/PaymentDeadline';

class CreditCard extends Component {
  render() {
    const selected_brand = this.props.brands.filter((brand) => brand.selected)[0];
    let parcel_option, parcels;

    if (selected_brand !== undefined) {
      parcel_option = selected_brand.max_parcels;
      parcels = [];
      for (let i = parcel_option; i > 0; i--) {
        parcels = parcels.concat({ times: i, price: this.props.final_price / i });
      }
    }

    return (
      <div className="area-cartao-credito">
        {!this.props.mobile && (
          <CardBrand brands={this.props.brands} selectCreditCardBrand={this.props.selectCreditCardBrand} />
        )}

        <div className="area-dados-cartoes flex">

          <div className="flex area-form-cartao">
            {!this.props.mobile ? (
              <CardInfo
                paymentOption="credit"
                errors={this.props.errors}
                creditCard={this.props.creditCard}
                changeCreditCardAttr={this.props.changeCreditCardAttr}
                brands={this.props.brands}
                validatorHandlerBlur={this.props.validatorHandlerBlur}
                selectCreditCardBrand={this.props.selectCreditCardBrand}
              />
            ) : (
              <CardInfoMobile
                paymentOption="credit"
                errors={this.props.errors}
                creditCard={this.props.creditCard}
                changeCreditCardAttr={this.props.changeCreditCardAttr}
                brands={this.props.brands}
                parcels={this.props.parcels}
                selectPaymentCreditCard={this.props.selectPaymentCreditCard}
                stepDisplayCreditCard={3}
                boxEditCard={this.props.boxEditCard}
                validatorHandlerBlur={this.props.validatorHandlerBlur}
                selectCreditCardBrand={this.props.selectCreditCardBrand}
                selectCreditCardParcel={this.props.selectCreditCardParcel}
              />
            )}
          </div>
          {this.props.parcels.length ? (
            <PaymentDeadline parcels={this.props.parcels} selectCreditCardParcel={this.props.selectCreditCardParcel} />
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      creditCard: state.purchase.creditCard,
      errors: state.purchase.errors.creditCard,
      brands: state.purchase.creditCard.brands,
      parcels: state.purchase.creditCard.parcels,
      final_price: state.purchase.purchaseSummary.total,
      mobile: state.mobile.mobileActive,
      stepDisplayCreditCard: state.purchase.stepDisplayCreditCard,
    }),
    {
      changeCreditCardAttr,
      selectCreditCardBrand,
      selectCreditCardParcel,
      selectPaymentCreditCard,
      validatorHandlerBlur,
    }
  )(CreditCard)
);



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/CreditCard.jsx